export const nlSetting = {
    months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
    monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
    weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
    weekdaysShort: "zo_ma_di_wo_do_vr_za".split("_"),
    weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),

    longDateFormat: {
        LT: "HH:mm",
        L: "DD-MM-YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY LT",
        LLLL: "dddd D MMMM YYYY LT"
    },

    calendar: {
        sameDay: '[Vandaag om] LT',
        nextDay: '[Morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[Gisteren om] LT',
        lastWeek: '[Afgelopen] dddd [om] LT',
        sameElse: 'L'
    },

    relativeTime: {
        future: function (s: any) {
            return "over " + s;
        },
        past: "%s geleden",
        s: "een paar seconden",
        m: "één minuut",
        mm: "%d minuten",
        h: "één uur",
        hh: "%d uur",
        d: "één dag",
        dd: "%d dagen",
        M: "één maand",
        MM: "%d maanden",
        y: "één jaar",
        yy: "%d jaar"
    },

    ordinal: '%d.',

    week: {
        dow: 1, // Monday is the first day of the week
        doy: 4
    }
}
